import React from "react";
import type {FunctionComponent} from "react";
import {useWhenSongDetailsLoadedWithoutLessonsLogic} from "./WhenSongDetailsLoadedWithoutLessons.logic";

export const WhenSongDetailsLoadedWithoutLessons: FunctionComponent = ({children}) => {
  const {isConditionPassed} = useWhenSongDetailsLoadedWithoutLessonsLogic();
  if (!isConditionPassed) {
    return null;
  }
  return <>{children}</>;
}
